import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useUser } from '../../context/UserContext';
import { LayoutDashboardIcon, MapIcon, UserIcon, MenuIcon, XIcon, LogOutIcon, LeafIcon } from 'lucide-react';
const Navigation: React.FC = () => {
  const {
    userData,
    resetUserData
  } = useUser();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navItems = [{
    path: '/dashboard',
    label: 'Dashboard',
    icon: LayoutDashboardIcon
  }, {
    path: '/quests',
    label: 'Garden Quests',
    icon: MapIcon
  }, {
    path: '/profile',
    label: 'Profile',
    icon: UserIcon
  }];
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  const handleLogout = () => {
    if (window.confirm('Are you sure you want to log out?')) {
      resetUserData();
    }
  };
  return <div className="w-full" data-id="element-42">
      {/* Desktop Navigation */}
      <div className="hidden md:flex justify-between items-center py-4 px-6 bg-white bg-opacity-10 backdrop-filter backdrop-blur-lg rounded-xl mb-6" data-id="element-43">
        <div className="flex items-center" data-id="element-44">
          <Link to="/dashboard" className="flex items-center" data-id="element-45">
            <LeafIcon className="text-green-500 mr-2" size={24} data-id="element-46" />
            <span className="text-xl font-bold text-white" data-id="element-47">
              <span className="text-pink-300" data-id="element-48">Seven</span>After
            </span>
          </Link>
        </div>
        <div className="flex space-x-1" data-id="element-49">
          {navItems.map(item => {
          const isActive = location.pathname === item.path;
          const Icon = item.icon;
          return <Link key={item.path} to={item.path} className={`px-4 py-2 rounded-lg flex items-center transition-colors ${isActive ? 'bg-white bg-opacity-20 text-white' : 'text-white text-opacity-70 hover:text-opacity-100 hover:bg-white hover:bg-opacity-10'}`} data-id="element-50">
                <Icon size={18} className="mr-2" data-id="element-51" />
                {item.label}
              </Link>;
        })}
          <button onClick={handleLogout} className="px-4 py-2 rounded-lg text-white text-opacity-70 hover:text-opacity-100 hover:bg-white hover:bg-opacity-10 flex items-center transition-colors" data-id="element-52">
            <LogOutIcon size={18} className="mr-2" data-id="element-53" />
            Logout
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      <div className="md:hidden flex justify-between items-center py-3 px-4 bg-white bg-opacity-10 backdrop-filter backdrop-blur-lg rounded-xl mb-6" data-id="element-54">
        <Link to="/dashboard" className="flex items-center" data-id="element-55">
          <LeafIcon className="text-green-500 mr-2" size={20} data-id="element-56" />
          <span className="text-lg font-bold text-white" data-id="element-57">
            <span className="text-pink-300" data-id="element-58">Seven</span>After
          </span>
        </Link>
        <button onClick={toggleMobileMenu} className="p-2 rounded-lg bg-white bg-opacity-10 text-white" data-id="element-59">
          {isMobileMenuOpen ? <XIcon size={20} data-id="element-60" /> : <MenuIcon size={20} data-id="element-61" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden fixed inset-0 z-50 bg-gradient-to-br from-indigo-900 to-purple-900 bg-opacity-98" data-id="element-62">
          <div className="flex flex-col h-full" data-id="element-63">
            <div className="flex justify-between items-center p-4 border-b border-white border-opacity-10" data-id="element-64">
              <span className="text-xl font-bold text-white" data-id="element-65">
                <span className="text-pink-300" data-id="element-66">Seven</span>After
              </span>
              <button onClick={toggleMobileMenu} className="p-2 rounded-lg bg-white bg-opacity-10 text-white" data-id="element-67">
                <XIcon size={20} data-id="element-68" />
              </button>
            </div>
            <div className="flex-grow overflow-y-auto p-4" data-id="element-69">
              <div className="flex flex-col space-y-2" data-id="element-70">
                {navItems.map(item => {
              const isActive = location.pathname === item.path;
              const Icon = item.icon;
              return <Link key={item.path} to={item.path} onClick={toggleMobileMenu} className={`px-4 py-3 rounded-lg flex items-center transition-colors ${isActive ? 'bg-white bg-opacity-20 text-white' : 'text-white text-opacity-70 hover:text-opacity-100 hover:bg-white hover:bg-opacity-10'}`} data-id="element-71">
                      <Icon size={20} className="mr-3" data-id="element-72" />
                      {item.label}
                    </Link>;
            })}
              </div>
              <div className="mt-8 pt-6 border-t border-white border-opacity-10" data-id="element-73">
                <div className="flex items-center px-4 py-3 mb-4" data-id="element-74">
                  <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center mr-3" data-id="element-75">
                    <UserIcon className="text-green-600" size={20} data-id="element-76" />
                  </div>
                  <div data-id="element-77">
                    <p className="text-white font-medium" data-id="element-78">
                      {userData.name || 'Garden Explorer'}
                    </p>
                    <p className="text-white text-opacity-70 text-sm" data-id="element-79">
                      {userData.humanDesignType || 'Sacred Gardener'}
                    </p>
                  </div>
                </div>
                <button onClick={() => {
              handleLogout();
              toggleMobileMenu();
            }} className="w-full px-4 py-3 rounded-lg bg-white bg-opacity-10 text-white flex items-center justify-center hover:bg-opacity-20 transition-colors" data-id="element-80">
                  <LogOutIcon size={18} className="mr-2" data-id="element-81" />
                  Logout
                </button>
              </div>
            </div>
          </div>
        </div>}
    </div>;
};
export default Navigation;